export default __webpack_public_path__ + "static/media/hotTubHeating.031de955.jpg";